import { AgendaItemDetailModel } from "models/AgendaItemDetailModel";
import { createContext } from "react";

export interface DocumentsPanelContextProps {
  isOpen: boolean;
  isLoading: boolean;
  agendaItem: AgendaItemDetailModel | undefined;
  openDocumentsPanel: (agendaItemId: number) => void;
  closeDocumentsPanel: () => void;
  reloadMeeting: () => void;
}

export const DocumentsPanelContext = createContext({} as DocumentsPanelContextProps);
